import React, { useEffect } from "react";
import '../css/noticeDetail.css'
import { useLocation, useNavigate } from "react-router-dom";

// 공지사항 상세 페이지
export const NoticeDetail = () => {

    // 네비게이션 사용 선언
    const navigate = useNavigate();

    // 공지사항 페이지에서 전달 받은 공지사항 데이터 추출
    const { state: noticeData } = useLocation();
    const {                // 받은 데이터에서 필요한 데이터 구조 분해 할당
        title = "",          // 공지사항 제목
        content = "",        // 공지사항 내용
        contentImgURL,     // 공지사항 내용 상단 이미지
        createdAt = "",      // 공지사항 생성일
    } = noticeData;

    const noticeDate = createdAt.match(/\d{4}-\d{2}-\d{2}/)[0]; // 공지 날짜에서 년, 월, 일 추출

    // 직접적으로 디테일 페이지에 접근했을 경우 공지사항 데이터가 없다면 공지사항 페이지로 강제 이동
    useEffect(() => {
        if (!noticeData) navigate("/notice");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // 목록 버튼 클릭 시 반응
    const onClickBacktoList = () => {
        navigate("/notice");
    }

    return (
        <div className="noticeDetail">

            {/* 공지사항 디테일 정보 라인 */}
            <div className="topLine">
                <div id="title">{title}</div>
                <div id="noticeDate">{noticeDate}</div>
            </div>

            {/* 공지사항 디테일 내용 라인 */}
            <div id="contentLine">
                {contentImgURL && <img src={contentImgURL} alt="" />}
                <div dangerouslySetInnerHTML={{ __html: content }} id="content" />
            </div>
            <input type="button" className="backToListBtn" value={"목록"} onClick={onClickBacktoList} />
        </div>
    )
}

export default NoticeDetail;